// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1n55g{width:100%}._2igAW{width:100%;height:52px;color:#9b9b9b;border:1px solid #ddd;border-radius:12px;margin-bottom:5px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;font-size:16px;font-weight:400}._2igAW,._2igAW:hover{background-color:#fff}._2x7WF{color:#9b9b9b;font-size:16px;width:100%;margin-bottom:5px}._3ouel{width:100%;overflow:hidden;white-space:nowrap}._1guhP{font-size:.75em!important;color:#f44336;cursor:default}._8B2MH{color:#f44336!important;-webkit-animation:_8B2MH .7s infinite alternate!important;animation:_8B2MH .7s infinite alternate!important;font-size:12px!important}@-webkit-keyframes _8B2MH{0%{opacity:.3}to{opacity:1}}@keyframes _8B2MH{0%{opacity:.3}to{opacity:1}}", ""]);
// Exports
exports.locals = {
	"fileInputContainer": "_1n55g",
	"fileInput": "_2igAW",
	"label": "_2x7WF",
	"placeholder": "_3ouel",
	"helperText": "_1guhP",
	"alert": "_8B2MH"
};
module.exports = exports;
